import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { HiOutlineShoppingBag } from "react-icons/hi2";
import { CgMenuLeftAlt, CgClose } from "react-icons/cg";
import { useCartContext } from '../context/cart_context';
import { Button } from '../styles/Button';
import DropdownProfile from '../auth/DropDownProfile'
import { useAuthStore } from '../store/store';
import useFetch from '../hooks/fetch.hook';
import user from '../assets/user.png'
import { TbUserSquareRounded } from "react-icons/tb";

const Nav = () => {
  const [menuIcon, setMenuIcon] = useState();
  const [openProfile, setOpenProfile] = useState(false);
  const { total_item } = useCartContext();
  const navigate = useNavigate();
  const { auth, setLoginStatus } = useAuthStore();
  const isLoggedIn = auth?.isLoggedIn;
 
  function userLogout() {
    localStorage.removeItem('token');    
    setLoginStatus(false);
    navigate('/username');
  }

return (
   <NavWrapper>    
      <div className={menuIcon ? "navbar active" : "navbar"}>
        <div className="profile">
           {isLoggedIn ? (
              <DropdownProfile onLogout={userLogout}/>
          ) : (            
            <button className="profile-btn">
              <NavLink to='/username'>
              <TbUserSquareRounded />
            </NavLink>
            </button>
          )}
        
        </div>
        <ul className='navbar-lists'>
          <li>
            <NavLink to="/" className="navbar-link home-link" onClick={() => setMenuIcon(false)}>Home</NavLink>
          </li>
          <li>
            <NavLink to="/about" className="navbar-link " onClick={() => setMenuIcon(false)}>About</NavLink>
          </li>
          <li>
            <NavLink to="/products" className="navbar-link " onClick={() => setMenuIcon(false)}>product</NavLink>
          </li>
          <li>
            <NavLink to="/contact" className="navbar-link " onClick={() => setMenuIcon(false)}>contact</NavLink>
          </li>
          
          <div className='profile-main'>
          {isLoggedIn ? (
            <li>
              <DropdownProfile onLogout={userLogout}  
              onClick={() => setMenuIcon(false)} />
            </li>
          ) : (
            <li>
              <Button><NavLink to="/username"  
              onClick={() => setMenuIcon(false)}>Login</NavLink>
              </Button>
            </li>
          )}
        
          </div>

          <li>
            <NavLink to="/cart" className="navbar-link cart-trolley--link" onClick={() => setMenuIcon(false)}>
              <HiOutlineShoppingBag className='cart-trolley' />
              <span className='cart-total--item'>{total_item}</span>
            </NavLink>
          </li>
        </ul>

        <div class='mobile-navbar-btn'>
          <CgMenuLeftAlt aria-label="Open menu" name='menu-outline' className='mobile-nav-icon' onClick={() => setMenuIcon(true)} />
          <CgClose aria-label="Close menu" name='close-outline' className='mobile-nav-icon close-outline' onClick={() => setMenuIcon(false)} />
        </div>
      </div>
    </NavWrapper>
    )
}


const NavWrapper = styled.nav`


/* Profile hidden on desktop */

/* Navbar links */

.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.navbar-lists {
  display: flex;
  gap: 4.8rem;
  align-items: center;
}
.navbar-link {
    &:link,
    &:visited {
      display: inline-block;
      color: ${({ theme }) => theme.colors.font};
      text-decoration: none;
      font-size: 2rem;
      font-weight: 500;
      text-transform: uppercase;
      transition: color 0.3s linear;
    }

    &:hover,
    &:active {
      color: ${({ theme }) => theme.colors.helper};
    }
  }

.profile {
  display: none;
  position: absolute;
  }

  .profile-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  border: none;
  background: none;
}

.profile-img {
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
}

.profile-name {
  font-size: 1.2rem;
}

/* Icons */
svg {
  font-size: 4rem;
  margin-top: 1rem;
}

/* Mobile navbar toggle */
.mobile-navbar-btn {
  display: none;
  background: transparent;
  cursor: pointer;
  border: none;
  z-index: 1000;
}

.mobile-nav-icon {
  font-size: 4rem;
  margin-top: 1rem;
}

.close-outline {
  display: none;
}

.active .close-outline {
  display: inline-block;
}

.active .mobile-nav-icon[name="menu-outline"] {
  display: none;
}

/* Cart badge */
.cart-trolley--link {
  position: relative;

  .cart-trolley {
    position: relative;
  }

  .cart-total--item {
    width: 2.5rem;
    height: 2.5rem;
    position: absolute;
    color: #fff;
    border-radius: 50%;
    display: grid;
    place-items: center;
    top: 0;
    left: 70%;
    background-color: ${({ theme }) => theme.colors.font};
  }
}

/* User login/logout buttons */
.user-login--name {
  text-transform: capitalize;
  font-size: 3em;
  border: 2px solid red;
}

.user-logout,
.user-login {
  font-size: 1.4rem;
  padding: 0.8rem 1.4rem;
  border: 2px solid red;
}

/* Mobile styles */
@media (max-width: ${({ theme }) => theme.media.mobile}) {
  .profile {
    display: block;
    position: relative;
  }

   .navbar-lists {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    visibility: hidden;
    transform: translateX(100%);
    transition: all 2s ease-in-out;
    z-index: 1000;
  }

  .active .navbar-lists {
    visibility: visible;
    transform: translateX(0);
    z-index: 1000;

  .navbar-link {
    font-size: 2.4rem;
    margin: 1.5rem 0;
    }
  }

 
  .mobile-navbar-btn {
    display: inline-block;
  }

  .navbar {
    display: flex;
    flex-direction: row;
    gap: 10px;
  }

 
  .cart-trolley--link .cart-trolley {
    font-size: 5.2rem;
  }

  .cart-trolley--link .cart-total--item {
    width: 4.2rem;
    height: 4.2rem;
    font-size: 2rem;
  }

  .profile-main {
    display: none;
  }

  .user-logout,
  .user-login {
    font-size: 2.2rem;
    padding: 0.8rem 1.4rem;
  }
}


`;


export default Nav;
